<template>
    <client-page>
        
        <sub-visual
        sh="사업분야"
        sc="에프원시큐리티는 전문가들로 이루어져 있습니다."
        tabActive="컨설팅 사업"
        icon="/images/sub/visual/sv2-icon.svg"
        bg="/images/sub/visual/sv2.png">
        </sub-visual>

        <section class="sub-section" id="consulting">
            <v-container>
                <v-row class="row--xx-small">
                    <v-col cols="12" lg="5" xl="4" data-aos="fade-right">
                        <h4 class="consulting-tit sub-tit--md font-weight-bold">
                            정보보호 컨설팅 서비스
                        </h4>
                    </v-col>
                    <v-col cols="12" lg="7" xl="8" data-aos="fade-left">
                        <p class="sub-tit--sm color-gray line-height-16">
                            F1Security 정보보호 컨설팅 서비스는 고객의 정보자산을 각종 위협으로부터 안전하게 <br class="d-none d-xl-block">
                            보호하기 위하여 Risk 관리를 기반으로 다양한 분야의 정보보안 컨설팅 서비스를 제공합니다. <br>
                            기본적인 정보보호 컨설팅을 기준으로 취약점 진단 컨설팅, 정보보호 인증지원 컨설팅, <br class="d-none d-xl-block">
                            주요 정보통신기반시설 컨설팅, 개인정보보호 컨설팅 등 전문적이고 품질 높은 종합 정보보호 <br class="d-none d-xl-block">
                            컨설팅 서비스를 지속적으로 제공하고 있습니다.
                        </p>
                    </v-col>
                </v-row>
            </v-container>
        </section>

        <section class="sub-section-sm bg-grey">
            <v-container>
                <v-img class="d-none d-lg-block mx-auto" max-width="968" src="/images/sub/business/consulting/consulting-img1.png"></v-img>
                <v-img class="d-block d-lg-none mx-auto" max-width="670" src="/images/sub/business/consulting/consulting-img1-mo.png"></v-img>
            </v-container>
        </section>

        <section class="sub-section pt-40 pt-md-80 pt-lg-100">
            <v-container>
                <div class="consulting-table page-text mb-80 mb-md-100 mb-lg-140">
                    <div class="thead d-none d-lg-block">
                        <div class="tr">
                            <div class="th">
                                <p>분류</p>
                            </div>
                            <div class="th">
                                <div class="table-detail">
                                    <p>컨설팅</p>
                                    <p>내용</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tbody">
                        <div class="tr">
                            <div class="th">
                                정보보호 인증 컨설팅
                            </div>
                            <div class="td">
                                <div class="table-detail">
                                    <p>
                                        ISMS, ISMS-P, ISO27001
                                    </p>
                                    <p>
                                        정보통신망의 안전성 확보를 위하여 수립·운영하고 있는 기술적·물리적 보호조치 등
                                        종합적인 정보보호(개인정보보호)관리체계에 대한 인증 획득
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="tr">
                            <div class="th">
                                정보보호 및 <br class="d-none d-lg-block">
                                개인정보보호 컨설팅
                            </div>
                            <div class="td">
                                <div class="table-detail">
                                    <p>
                                        정보보호 체계구축
                                    </p>
                                    <p>
                                        기업의 정보시스템 안전성/신뢰성 증대 및 비즈니스 경쟁력 향상을 위한 국내/국제
                                        보안표준에 의거한 종합적인 정보보호 관리체계 구축
                                    </p>
                                </div>
                                <div class="table-detail">
                                    <p>
                                        개인정보보호 체계구축
                                    </p>
                                    <p>
                                        개인정보의 라이프사이클에 걸쳐 개인정보를 취급하는 시스템과 취급프로세스에
                                        존재하는 위협과 취약점을 식별하고 위험을 평가하여 기업에 적합한 보호대책 수립
                                    </p>
                                </div>
                                <div class="table-detail">
                                    <p>
                                        정보보호 마스터플랜
                                    </p>
                                    <p>
                                        기업의 주요 정보자산에 대한 관리/물리/기술적 취약점 및 위험분석을 통해 체계적
                                        보안 마스터플랜 수립
                                    </p>
                                </div>
                                <div class="table-detail">
                                    <p>
                                        보안감사
                                    </p>
                                    <p>
                                        기업의 보안체계가 효율적으로 운영되고 있는지를 문서체계 및 증빙자료, 실사 등을
                                        통해 점검
                                    </p>
                                </div>
                                <div class="table-detail">
                                    <p>
                                        모의해킹
                                    </p>
                                    <p>
                                        해커의 관점으로 IT 서비스의 주요 취약점을 도출하고 해결방안 제시

                                    </p>
                                </div>
                                <div class="table-detail">
                                    <p>
                                        기술취약점 진단
                                    </p>
                                    <p>
                                        기업의 중요 인프라시스템(서버/DB/어플리케이션/네트워크/보안시스템 등)에
                                        존재하는 취약점을 도출하여 해결방안 제시
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="tr">
                            <div class="th">
                                정보보호 솔루션
                            </div>
                            <div class="td">
                                <div class="table-detail">
                                    <p>
                                        정보보호 솔루션
                                    </p>
                                    <p>
                                        고객사 환경분석 후 각 영역별/기능성/성능면에서 최적의 보안솔루션 제공
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mb-26 mb-lg-42">
                    <h4 class="sub-tit--md mb-8 mb-lg-20" data-aos="fade-up">
                        컨설팅 방법론 전략
                    </h4>
                    <p class="sub-tit--sm color-gray">
                        고객사의 업무특성 및 현황을 정확히 이해하고, 최적화된 정보보호관리체계를 구축·운영하는 것으로써, 체계적인 컨설팅을 수행합니다.
                    </p>
                </div>

                <div class="radius-md bg-gra pa-30 px-md-16 py-md-70 color-white text-center">
                    <div class="row-cols-2 row-cols-md-3 row-cols-lg-5 d-flex flex-wrap justify-center consulting-item-group ma-n16 ma-md-n30 ma-lg-0">
                        <div class="pa-16 pa-md-30 px-lg-16 py-lg-0 consulting-item" data-aos="fade-right" data-aos-delay="100">
                            <div class="d-flex flex-column align-center">
                                <img src="/images/sub/business/consulting/consulting-icon1.png" alt="" class="d-block mb-12 mb-lg-24">
                                <p class="page-text">
                                    정보보호 컨설팅에 <br class="d-none d-xl-block">
                                    적합한 전문 컨설턴트 <br class="d-none d-xl-block">
                                    선별 투입
                                </p>
                            </div>
                        </div>
                        <div class="pa-16 pa-md-30 px-lg-16 py-lg-0 consulting-item">
                            <div class="d-flex flex-column align-center" data-aos="fade-right" data-aos-delay="400">
                                <img src="/images/sub/business/consulting/consulting-icon2.png" alt="" class="d-block mb-12 mb-lg-24">
                                <p class="page-text">
                                    보안관련 Compliance 등 <br class="d-none d-xl-block">
                                    기업환경에 대한 명확한 <br class="d-none d-xl-block">
                                    이해 확보
                                </p>
                            </div>
                        </div>
                        <div class="pa-16 pa-md-30 px-lg-16 py-lg-0 consulting-item">
                            <div class="d-flex flex-column align-center" data-aos="fade-right" data-aos-delay="700">
                                <img src="/images/sub/business/consulting/consulting-icon3.png" alt="" class="d-block mb-12 mb-lg-24">
                                <p class="page-text">
                                    최신 보안기술을 <br class="d-none d-xl-block">
                                    활용 취약점 진단 및 <br class="d-none d-xl-block">
                                    대책수립
                                </p>
                            </div>
                        </div>
                        <div class="pa-16 pa-md-30 px-lg-16 py-lg-0 consulting-item">
                            <div class="d-flex flex-column align-center" data-aos="fade-right" data-aos-delay="1000">
                                <img src="/images/sub/business/consulting/consulting-icon4.png" alt="" class="d-block mb-12 mb-lg-24">
                                <p class="page-text">
                                    자율적인 정보보호 <br class="d-none d-xl-block">
                                    관리체계 정착을 위한 <br class="d-none d-xl-block">
                                    실행력 극대화
                                </p>
                            </div>
                        </div>
                        <div class="pa-16 pa-md-30 px-lg-16 py-lg-0 consulting-item">
                            <div class="d-flex flex-column align-center" data-aos="fade-right" data-aos-delay="1300">
                                <img src="/images/sub/business/consulting/consulting-icon5.png" alt="" class="d-block mb-12 mb-lg-24">
                                <p class="page-text">
                                    지식 내재화를 <br class="d-none d-xl-block">
                                    위한 실질적인 <br class="d-none d-xl-block">
                                    지식전수
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </v-container>
        </section>

        <v-container>
            <v-divider></v-divider>
        </v-container>

        <section class="sub-section sub-section--last">
            <v-container>
                <div class="mb-40 mb-md-80 mb-lg-100">
                    <v-row>
                        <v-col cols="12" lg="6" class="mb-20 mb-lg-0">
                            <h4 class="sub-tit--md mb-8 mb-lg-20" data-aos="fade-up">
                                컨설팅 방법론
                            </h4>
                            <p class="sub-tit--sm color-gray mb-8 mb-lg-20">
                                F1Security 방법론은 ISMS, ISMS-P, ISO27001 등 <br class="d-none d-lg-block">
                                인증을  비롯한 국내외 보안모델을 참고하여 만든 방법론으로써 <br class="d-none d-lg-block">
                                각 모듈이 유기적으로 연결되어 있으며 고객사의 정보보호 <br class="d-none d-lg-block">
                                관리체계 수립에 적용되어 성공적인 컨설팅을 수행하도록 합니다.
                            </p>
                            <p class="sub-tit--sm color-gray">
                                취약점 진단 시 이용하는 체크리스트는 국내외 보안모델 및 <br class="d-none d-lg-block">
                                제조사의 보안가이드 등을 고려하여 관리/물리 및 <br class="d-none d-lg-block">
                                기술적 영역에 다양한 체크리스트를 보유하고 있어 <br class="d-none d-lg-block">
                                모든 유형의 정보자산에 대해 취약점 진단을 실시할 수 있습니다.
                            </p>
                        </v-col>
                        <v-col cols="12" lg="6">
                            <v-img class="d-block mx-auto" max-width="440" src="/images/sub/business/consulting/consulting-img2.png"></v-img>
                        </v-col>
                    </v-row>
                </div>
                <div class="mb-40 mb-md-80 mb-lg-100">
                    <h4 class="line-txt" data-aos="fade-up">
                        정보보호 기준
                    </h4>
                    <v-img class="d-none d-lg-block" max-width="1200" src="/images/sub/business/consulting/consulting-img3.png"></v-img>
                    <v-img class="d-block d-lg-none mx-auto" max-width="670" src="/images/sub/business/consulting/consulting-img3-mo.png"></v-img>
                </div>
                <div class="mb-40 mb-md-80 mb-lg-100">
                    <h4 class="line-txt" data-aos="fade-up">
                        정보보호관리체계 인증 컨설팅
                    </h4>
                    <div class="w-100 radius-md border page-text mb-12 mb-lg-14">
                        <v-row no-gutters class="pa-16 pa-md-0">
                            <v-col cols="12" md="3" class="pa-md-24 mb-4 mb-md-0">
                                <p class="right-line font-weight-bold">KISA ISMS/ISMS-P 인증</p>                                
                            </v-col>
                            <v-col cols="12" md="9" class="pa-md-24">
                                <p class="color-gray">
                                    개인정보 및 정보 자산조사, 개인정보 흐름분석, 위험평가, 개인정보 및 정보보호대책 수립
                                </p>
                            </v-col>
                        </v-row>
                    </div>
                    <div class="w-100 radius-md border page-text mb-12 mb-lg-14">
                        <v-row no-gutters class="pa-16 pa-md-0">
                            <v-col cols="12" md="3" class="pa-md-24 mb-4 mb-md-0">
                                <p class="right-line font-weight-bold">ISO27001 인증</p>                                
                            </v-col>
                            <v-col cols="12" md="9" class="pa-md-24">
                                <p class="color-gray">
                                    자산분석, 위험평가, 적용성 보고서, 내부감사
                                </p>
                            </v-col>
                        </v-row>
                    </div>
                </div>
                <div>
                    <h4 class="line-txt" data-aos="fade-up">
                        취약점 분석 컨설팅
                    </h4>
                    <div class="w-100 radius-md border page-text mb-12 mb-lg-14">
                        <v-row no-gutters class="pa-16 pa-md-0">
                            <v-col cols="12" md="3" class="pa-md-24 mb-4 mb-md-0">
                                <p class="right-line font-weight-bold">서버/네트워크/보안장비/응용진단</p>                                
                            </v-col>
                            <v-col cols="12" md="9" class="pa-md-24">
                                <p class="color-gray">
                                    IT 인프라 및 서비스 자산조사, 취약점 분석, 보호대책 수립
                                </p>
                            </v-col>
                        </v-row>
                    </div>
                    <div class="w-100 radius-md border page-text mb-12 mb-lg-14">
                        <v-row no-gutters class="pa-16 pa-md-0">
                            <v-col cols="12" md="3" class="pa-md-24 mb-4 mb-md-0">
                                <p class="right-line font-weight-bold">모의해킹</p>                                
                            </v-col>
                            <v-col cols="12" md="9" class="pa-md-24">
                                <p class="color-gray">
                                    시나리오 기반의 모의해킹 수행
                                </p>
                            </v-col>
                        </v-row>
                    </div>
                    <div class="w-100 radius-md border page-text mb-12 mb-lg-14">
                        <v-row no-gutters class="pa-16 pa-md-0">
                            <v-col cols="12" md="3" class="pa-md-24 mb-4 mb-md-0">
                                <p class="right-line font-weight-bold">소스분석</p>                                
                            </v-col>
                            <v-col cols="12" md="9" class="pa-md-24">
                                <p class="color-gray">
                                    어플리케이션 소스 취약점 분석
                                </p>
                            </v-col>
                        </v-row>
                    </div>
                </div>
            </v-container>
        </section>

    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
    },
};
</script>

<style lang="scss" scoped>

.consulting-table{
    border-top: 2px solid var(--v-primary-base);
    width: 100%;
}

.consulting-table .thead p{
    padding: 16px;
    justify-content: center;
}

.consulting-table .th{
    font-weight: 700;
}

.consulting-table .th{
    font-size: 1.6rem;
    margin-bottom: 12px;
}

.consulting-table .tr{
    width: 100%;;
    border-bottom: 1px solid var(--border-color);
    padding: 16px;
}

.table-detail{
    width: 100%;
}

.consulting-table .tbody p{
    color: #777;
}

.consulting-table .table-detail>*:nth-child(1){
    font-weight: 700;
}

.consulting-table .tbody .tr>* .table-detail:not(:last-child){
    margin-bottom: 6px;
}

@media (min-width:576px){
}
@media (min-width:768px){
    .table-detail{
        display: flex;
    }
    .table-detail p{
        display: flex;
        align-items: center;
    }
    .consulting-table .table-detail>*:nth-child(1){
        width: 26%;
    }

    .consulting-table .table-detail>*:nth-child(2){
        width: 74%;
    }

    .right-line{
        position: relative;
    }

    .right-line::after{
        content: "";
        display: block;
        position: absolute;
        width: 1px;
        height: 16px;
        background-color: var(--border-color);
        top: 50%;
        right: 0;
        transform: translateY(-50%);
    }
}
@media (min-width:1024px){
    .consulting-tit{
        white-space: nowrap;
    }

    .consulting-table .tbody p{
        padding: 24px 36px;
    }

    .consulting-table .tbody .tr>* .table-detail:not(:last-child){
        border-bottom: 1px solid var(--border-color);
        margin-bottom: 0;
    }

    .consulting-table .th{
        background-color: #fcfcfc;
    }

    .consulting-table .tr{
        display: flex;
        padding: 0;
    }

    .consulting-table .tr>*:nth-child(1){
        width: 20%;
    }

    .consulting-table .tr>*:nth-child(2){
        width: 80%;
    }

    .consulting-table .tbody .table-detail>*:nth-child(1){
        font-weight: 400;
    }

    .consulting-table .tr>*:nth-child(1){
        width: 20%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .consulting-table .th{
        font-weight: 700;
        text-align: center;
    }

    .consulting-table .th{
        font-size: 1.8rem;
        margin-bottom: 0;
    }

    .consulting-item-group .consulting-item:not(:last-child){
        border-right: 1px solid rgba(217, 238, 252, 0.3);
    }
}
@media (min-width:1200px){
}


</style>